import { config, dashApi } from 'services/api';

export async function getEmailVerification(verification_code) {
  return dashApi.post('email_verification/',{ verification_code }, config(),);
}
